import { months } from 'constants/date';
import moment from 'moment';

import {
    SET_WEANING_DATA,
    SET_WEANING_DATA_LOADING,
    SET_WEANING_FILTER_OPTIONS,
    SET_WEANING_FILTERS,
    RESET_WEANING_FILTERS,
    SET_WEANING_PROPERTY_ID
} from '@/redux/mutations';

export const initialState = {
    property_id: null,
    data: {},
    loading: true,
    optionsFilters: {
        years: [moment().year()],
        months: months,
        sex: ['Todos'],
        isPurchased: ['Todos']
    },
    selectedFilters: {
        years: [moment().year()],
        months: ['Todos'],
        sex: 'Todos',
        isPurchased: 'Todos'
    }
};

const indicatorsPanelWeaningReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case SET_WEANING_PROPERTY_ID:
            return {
                ...state,
                property_id: actions.payload
            };
        case SET_WEANING_DATA:
            return {
                ...state,
                data: actions.payload
            };
        case SET_WEANING_DATA_LOADING:
            return {
                ...state,
                loading: actions.payload
            };
        case SET_WEANING_FILTER_OPTIONS:
            return {
                ...state,
                optionsFilters: actions.payload
            };
        case SET_WEANING_FILTERS:
            return {
                ...state,
                selectedFilters: actions.payload
            };
        case RESET_WEANING_FILTERS:
            return {
                ...state,
                selectedFilters: {
                    years: [moment().year()],
                    months: ['Todos'],
                    sex: 'Todos',
                    isPurchased: 'Todos'
                }
            };
        default:
            return state;
    }
};

export default indicatorsPanelWeaningReducer;
